var __jsx = React.createElement;
import React, { useState } from 'react';
import { Button, Dropdown, Card } from 'antd';
import { QuestionCircleOutlined, DownOutlined } from '@ant-design/icons';
import getDomainSpecificContent from 'utils/getDomainSpecificContent';
var HelpButton = function HelpButton() {
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var menuItems = [{
    label: /*#__PURE__*/React.createElement(Card, {
      size: "small",
      style: {
        padding: '1em',
        width: '380px'
      }
    }, getDomainSpecificContent('HelpButton')),
    key: 'help-button-contents'
  }];
  return /*#__PURE__*/React.createElement(Dropdown, {
    open: visible,
    onOpenChange: function onOpenChange(v) {
      return setVisible(v);
    },
    menu: {
      items: menuItems
    },
    placement: "bottomRight",
    trigger: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "dashed",
    icon: /*#__PURE__*/React.createElement(QuestionCircleOutlined, null)
  }, "Need help?", /*#__PURE__*/React.createElement(DownOutlined, null)));
};
export default HelpButton;